<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header">
            <span class="title">Users</span>
            <div class="float-right">
                <el-button
                  class="mr10"
                  icon="el-icon-download"
                  type="primary"
                  v-if="level3"
                  round
                  @click="downloadTemplate()"
                >
                  Tier Change Template
                </el-button>
                <el-button
                  class="mr10"
                  icon="el-icon-upload2"
                  type="success"
                  v-if="level3"
                  round
                  @click="importTierUpdate()"
                >
                  Tier Change Import
                </el-button>
                <el-button class="mr10" type="primary" v-if="level3 || level2" round @click="CSVexport()">
                  <i v-if="csvLoading" class="fa fa-spinner fa-spin"></i> Export CSV
                </el-button>
              <Filters :activeTab="activeTab" />
              <el-tooltip content="Insert" placement="top" v-if="level3">
                <el-button
                  type="success"
                  circle
                  icon="el-icon-plus"
                  @click.prevent="insert()"
                  class="ml10"
                ></el-button>
              </el-tooltip>
            </div>
          </div>
          <Dialog :activeTab="activeTab" />
          <el-tabs type="border-card" v-model="activeTab">
            <el-tab-pane label="All" name="all">
              <AllUsers />
            </el-tab-pane>
<!--            <el-tab-pane label="New Registrations" name="new-users">
              <NewUsers />
            </el-tab-pane>-->
            <el-tab-pane label="Creators" name="creators">
              <Creators />
            </el-tab-pane>
            <el-tab-pane label="Artists" name="artists">
              <Artists />
            </el-tab-pane>
            <el-tab-pane label="Labels" name="labels">
              <Labels />
            </el-tab-pane>
            <el-tab-pane label="Mcn" name="mcn">
              <Mcn />
            </el-tab-pane>
            <el-tab-pane label="Permissions" name="permissions" v-if="level3">
              <Permissions />
            </el-tab-pane>
            <el-tab-pane label="CID/Distro Submissions" name="cid_distro">
              <CIDSubmissionsTab />
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :title="invalidList.length > 0 ? 'Export Invalid List' : 'Import CSV'"
      :visible="importDialog"
      width="500px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="importDialog = false"
    >
      <div v-if="invalidList.length > 0">
        <el-button type="info" @click="exportCSVInvalid()">
          Download CSV
        </el-button>
      </div>
      <div v-else>
        <el-upload
          drag
          ref="upload"
          accept=".csv"
          :action="`${admin}user/csv/import`"
          :headers="headers"
          :file-list="fileList"
          :on-success="onSuccess"
          :on-error="onError"
          name="csv"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">*only csv files allowed</div>
        </el-upload>
      </div>
    </el-dialog>
    <SelectTier/>
  </div>
</template>

<script>
import Filters from '../components/Filters'
import AllUsers from '../components/AllUsers'
import NewUsers from "../components/NewUsers";
import Dialog from '../components/Dialog'
import { mapState, mapMutations, mapActions } from 'vuex'
import Artists from '@/modules/admin/user/components/Artists'
import Labels from '@/modules/admin/user/components/Labels'
import Creators from '@/modules/admin/user/components/Creators'
import Mcn from '@/modules/admin/user/components/Mcn'
import Permissions from '@/modules/admin/user/components/Permissions'
import CIDSubmissionsTab from '@/modules/admin/user/components/CIDSubmissionsTab.vue';
import axios from '@/plugins/axios'
import store from "../../../../plugins/vuex";
import SelectTier from '@/modules/admin/user/components/SelectTier.vue'

export default {
  data() {
    return {
      user: {
        id: null,
        email: null,
        first_name: null,
        surname: null,
        slug: null,
        label: null,
        artist: null,
        company_admin: null,
        country_of_residence: null
      },
      importDialog: false,
      fileList: [],
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT,
      admin: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      invalidList: [],
      activeTab: 'all'
    }
  },

  components: {
    Filters,
    AllUsers,
    NewUsers,
    Dialog,
    Artists,
    Labels,
    Creators,
    Mcn,
    Permissions,
    SelectTier,
    CIDSubmissionsTab,
  },

  computed: {
    ...mapState('user', ['dialog', 'csvLoading']),
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    },
    level2: function() {
      if (store.state.auth.user.permission === 2) return true
      else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('user', ['exportCSV', 'tierChangeTemplate', 'read']),
    ...mapMutations('user', [
        'setDialog', 'setSelectedUser', 'setShowWallet', 'setYoutubeCategories', 'setTiers'
    ]),
    initialUser() {
      return {
        id: null,
        email: null,
        first_name: null,
        surname: null,
        slug: null,
        label: null,
        artist: null,
        company_admin: null,
        country_of_residence: null,
        wallet: null
      }
    },
    insert() {
      this.setDialog(true)
      this.setShowWallet(false)
      this.setSelectedUser(this.initialUser())
    },
    CSVexport() {
      let ls = localStorage.getItem('user_filter'),
        filters = null
      ls = ls ? ls : '{}'
      filters = JSON.parse(ls)
      filters['csv'] = 1
      filters['company_admin'] = ''
      if(this.activeTab != 'all'){
        filters['user_level'] = this.getUserLevel(this.activeTab)
      }
      this.exportCSV(filters)
    },
    downloadTemplate() {
      this.tierChangeTemplate()
    },
    importTierUpdate() {
      this.importDialog = true
    },
    onSuccess(res) {
      this.importDialog = false
      this.read()
      this.$message({
        message: res.response.message,
        type: 'success'
      })
    },
    onError(err) {
      let res = JSON.parse(err.message)
      this.invalidList = res.data
      this.read()
      this.$message({
        message: res ? res.response.message : 'Upload error!',
        type: 'error'
      })
    },
    exportCSVInvalid() {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        Object.keys(this.invalidList[0]).join(','),
        ...this.invalidList.map(item => Object.values(item).join(','))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'invalid_tiers.csv')
      link.click()
      this.invalidList = []
      this.dialog = false
    },
    getUserLevel(tab){
      if(tab == 'creators'){
        return 'creator'
      }
      else if(tab == 'artists'){
        return 'artist_admin'
      }
      else if(tab == 'labels'){
        return 'label_admin'
      }
      else if(tab == 'mcn'){
        return 'company_user'
      }
      else if(tab == 'permissions'){
        return 'sysadmin'
      }
      else return ''
    }
  },
  async created() {
    let categories = await axios.api.get('/youtube/categories')
    if (categories.data.data) this.setYoutubeCategories(categories.data.data)

    let tiers = await axios.api.get('creator-tiers')
    if (tiers.data.success) this.setTiers(tiers.data.creatorTiers)
  }
}
</script>
